import React from "react";
import { Button } from "react-bootstrap";
import FormSection from "components/sales/formSection/formSectionNew";
import CardSection from "components/sales/cardSection/cardSection";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const yesNoOptions = [
  { id: 1, name: "Yes" },
  { id: 0, name: "No" },
];

const MrfTypeForm = ({
  formData,
  handleInputChange,
  setFormData,
  handleSubmit,
  dropdownData = {},
  isLoading,
  isEdit = false,
}) => {

  return (
    <FormSection>
      {/* ================= MRF HEADER ================= */}
      <CardSection title="MRF">
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label="Code"
              name="code"
              value={formData.code}
              handleChange={(value) =>
                setFormData((prev) => ({ ...prev, code: value }))
              }
              isStarRequired
              disabled={isEdit}
            />
          </div>

          <div className="col-md-6">
            <ConstantInput
              label="MRF Type"
              name="mrf_type"
              value={formData.mrf_type}
              handleChange={(value) =>
                setFormData((prev) => ({ ...prev, mrf_type: value }))
              }
              isStarRequired
              disabled={isEdit}
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Contract No. Mandatory"
              data={yesNoOptions}
              getValueById={formData.contract_no_mandatory}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "contract_no_mandatory", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Customer No. Mandatory"
              data={yesNoOptions}
              getValueById={formData.customer_no_mandatory}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "customer_no_mandatory", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Close MRF"
              data={yesNoOptions}
              getValueById={formData.close_mrf}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "close_mrf", value: val },
                })
              }
            />
          </div>

        </div>
      </CardSection>

      {/* ================= PARK - CAPEX ================= */}
      <CardSection title="Park - Capex Combination Type">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Scope"
              data={dropdownData?.type_of_scope || []}
              getValueById={formData.park_capex_scope}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_capex_scope", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={dropdownData?.type_of_site || []}
              getValueById={formData.park_capex_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_capex_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.park_capex_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_capex_txn", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Post Item Journal"
              data={yesNoOptions}
              getValueById={formData.park_capex_post_journal}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_capex_post_journal", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= PARK - OPEX ================= */}
      <CardSection title="Park - Opex Combination Type">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Scope"
              data={dropdownData?.type_of_scope || []}
              getValueById={formData.park_opex_scope}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_scope", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={dropdownData?.type_of_site || []}
              getValueById={formData.park_opex_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.park_opex_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_txn", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Fixed Asset Creation"
              data={yesNoOptions}
              getValueById={formData.park_opex_fixed_asset_creation}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_fixed_asset_creation", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Gen. Prod. Posting Group"
              data={dropdownData?.genPosting || []}
              getValueById={formData.park_opex_gen_prod_posting}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_gen_prod_posting", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Post Item Journal"
              data={yesNoOptions}
              getValueById={formData.park_opex_post_journal}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "park_opex_post_journal", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= CLIENT CAPEX ================= */}
      <CardSection title="Client Capex Combination Type">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Scope"
              data={dropdownData?.type_of_scope || []}
              getValueById={formData.client_capex_scope}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_capex_scope", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={dropdownData?.type_of_site || []}
              getValueById={formData.client_capex_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_capex_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.client_capex_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_capex_txn", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Gen. Prod. Posting Group"
              data={dropdownData?.genPosting || []}
              getValueById={formData.client_capex_gen_prod_posting}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_capex_gen_prod_posting", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Post Item Journal & JV"
              data={yesNoOptions}
              getValueById={formData.client_capex_post_journal}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_capex_post_journal", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= CLIENT OPEX ================= */}
      <CardSection title="Client Opex Combination Type">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Scope"
              data={dropdownData?.type_of_scope || []}
              getValueById={formData.client_opex_scope}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_opex_scope", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={dropdownData?.type_of_site || []}
              getValueById={formData.client_opex_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_opex_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.client_opex_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_opex_txn", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Post Item Journal"
              data={yesNoOptions}
              getValueById={formData.client_opex_post_journal}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "client_opex_post_journal", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= JV G/L ACCOUNTS ================= */}
      <CardSection title="JV G/L Accounts">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Debit G/L Account No."
              data={dropdownData?.gl_account || []}
              getValueById={formData.debit_gl_account}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "debit_gl_account", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Credit G/L Account No."
              data={dropdownData?.gl_account || []}
              getValueById={formData.credit_gl_account}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "credit_gl_account", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= ITEM JOURNAL ================= */}
      <CardSection title="Item Journal">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Gen. Prod. Posting Group"
              data={dropdownData?.genPosting || []}
              getValueById={formData.item_journal_gen_posting}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "item_journal_gen_posting", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= MATERIAL RETURN PROCESS ================= */}
      <CardSection title="Material Return Process">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Return"
              data={yesNoOptions}
              getValueById={formData.material_return}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "material_return", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.material_return_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "material_return_txn", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Gen. Prod. Posting Group"
              data={dropdownData?.genPosting || []}
              getValueById={formData.material_return_gen_prod_posting}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "material_return_gen_prod_posting", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <ConstantInput
              label="Depreciation Rate"
              name="depreciation_rate"
              type="number"
              value={formData.depreciation_rate}
              handleChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  depreciation_rate: value,
                }))
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= EMPTY COMBINATION TYPE ================= */}
      <CardSection title="Empty Combination Type">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Scope"
              data={dropdownData?.type_of_scope || []}
              getValueById={formData.empty_scope}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "empty_scope", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={dropdownData?.type_of_site || []}
              getValueById={formData.empty_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "empty_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Transaction Type"
              data={dropdownData?.transaction_type || []}
              getValueById={formData.empty_txn}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "empty_txn", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= TRANSFER-TO BIN ================= */}
      <CardSection title="Transfer-to Bin on Transfer Order">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Faulty Bin"
              data={yesNoOptions}
              getValueById={formData.faulty_bin}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "faulty_bin", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Bin Material Status"
              data={dropdownData?.bin_mat_status || []}
              getValueById={formData.bin_material_status}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "bin_material_status", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= TAG RETURN ================= */}
      <CardSection title="Tag Return Process">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Tag Return"
              data={yesNoOptions}
              getValueById={formData.tag_return}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "tag_return", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= DISMANTLE ================= */}
      <CardSection title="Dismantle Process">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Dismantle"
              data={yesNoOptions}
              getValueById={formData.dismantle}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "dismantle", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= VALIDATIONS ================= */}
      <CardSection title="Validations">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
              label="Type of Site"
              data={yesNoOptions}
              getValueById={formData.validation_type_of_site}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "validation_type_of_site", value: val },
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Neg./Sale Posted"
              data={yesNoOptions}
              getValueById={formData.validation_neg_sale_posted}
              getIdValue={(val) =>
                handleInputChange({
                  target: { name: "validation_neg_sale_posted", value: val },
                })
              }
            />
          </div>
        </div>
      </CardSection>

      {/* ================= SUBMIT ================= */}
      <div className="form-action-buttons" style={{ marginTop: 12 }}>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
          Submit
        </Button>
      </div>
    </FormSection>
  );
};

export default MrfTypeForm;